import { DeliveryState } from "../../../type/delivery-state";

export const clearSelectedDisplayDeliveryIdDispatch = (
  state: DeliveryState
) => {
  state.selectedDisplayDeliveryId = undefined;
};
